import { Injectable } from '@angular/core';
import { Subject } from 'rxjs';

@Injectable({
  providedIn: 'root'
})
export class ErrorHandlerService {

  private _err = new Subject<any>();
  public err = this._err.asObservable();

  constructor() { }

  public pushError(err){
    this._err.next(err);
  }

}
